<template>
  <img v-if="storybook" :src="src" :alt="alt ?? ''" :loading="loading as 'lazy' | 'eager' | undefined" class="object-cover" :width="width" :height="height" />
  <img
    v-else-if="isExternal || srcset"
    :src="src"
    :srcset="srcset"
    :sizes="srcset ? imgSizes : undefined"
    :alt="alt ?? ''"
    :loading="loading as 'lazy' | 'eager' | undefined"
    class="object-cover"
    :width="width"
    :height="height"
  />
  <nuxt-img
    v-else
    :src="cleanCloudinaryUrl(src || '')"
    :alt="alt"
    :provider="provider || 'cloudinary'"
    :loading="loading"
    :fit="fit"
    :width="width"
    :height="height"
    :sizes="sizes"
    :format="format"
    :modifiers="modifiers"
    :fetchpriority="fetchpriority"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
const props = defineProps({
  src: String,
  alt: String,
  format: String,
  provider: String,
  loading: String,
  sizes: String,
  fit: String,
  width: [String, Number],
  height: [String, Number],
  modifiers: Object,
  fetchpriority: String,
  // A ready-made srcset (already-transformed URLs) bypasses the provider; imgSizes is its
  // HTML `sizes`, since `sizes` above is @nuxt/image's breakpoint syntax.
  srcset: String,
  imgSizes: String,
})
const storybook = import.meta.env.STORYBOOK === 'true'

// Non-Cloudinary and Cloudinary fetch URLs are rendered as they are: the
// provider only understands upload public IDs, and a fetch URL already carries
// its transformations.
const isExternal = computed(() => {
  const url = props.src || ''
  const isCloudinary = url.includes('res.cloudinary.com')
  const isCloudinaryFetch = isCloudinary && url.includes('/image/fetch/')
  return url.startsWith('http') && (!isCloudinary || isCloudinaryFetch)
})

function cleanCloudinaryUrl(url: string): string {
  if (!url) return ''

  if (!url.includes('res.cloudinary.com')) return url

  // Match and extract the part after /upload/ and remove any transformations
  // This version strips everything between /upload/ and the actual public ID path
  const match = url.match(/\/upload\/(?:[^/]+,)*([^?]+)/)

  if (match?.[1]) {
    return decodeURIComponent(match[1])
  }

  // fallback
  const parts = url.split('/upload/')
  return decodeURIComponent(parts[1] || url)
}
</script>
